import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//登录注册
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import Register from '@/pages/Login/Register'
import RegisterInfo from '@/pages/Login/RegisterInfo'
import Forget from '@/pages/Login/Forget'

//发货单
import Invoice from '@/pages/Invoice/index'
import SendcarsOrder from '@/pages/Invoice/SendcarsOrder'
import TransportOrder from '@/pages/Invoice/TransportOrder'
import AddInvoice from '@/pages/Invoice/AddInvoice'
import AddMaterial from '@/pages/Invoice/AddMaterial'
//派车单
import Sendcars from '@/pages/Sendcars/index'
import SendcarsDetail from '@/pages/Sendcars/SendcarsDetail'
//授信
import Credit from '@/pages/Credit/index'
import CreditApply from '@/pages/Credit/Apply'
//缺省页
import Refresh from '@/pages/refresh'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '首页',
        needLogin: true //需要加校检判断的路由
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录',
      }
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta: {
        title: '注册',
      }
    },
    {
      path: '/RegisterInfo',
      name: 'RegisterInfo',
      component: RegisterInfo,
      meta: {
        title: '注册-填写信息',
      }
    },
    {
      path: '/Forget',
      name: 'Forget',
      component: Forget,
      meta: {
        title: '忘记密码',
      }
    },
    {
      path: '/Invoice',
      name: 'Invoice',
      component: Invoice,
      meta: {
        title: '发货单',
      }
    },
    {
      path: '/SendcarsOrder/:id',
      name: 'SendcarsOrder',
      component: SendcarsOrder,
      meta: {
        title: '对应派车单'
      }
    },
    {
      path: '/TransportOrder/:id',
      name: 'TransportOrder',
      component: TransportOrder,
      meta: {
        title: '对应运输单'
      }
    },
    {
      path: '/AddInvoice',
      name: 'AddInvoice',
      component: AddInvoice,
      meta: {
        title: '新增发货单'
      }
    },
    {
      path: '/AddMaterial',
      name: 'AddMaterial',
      component: AddMaterial,
      meta: {
        title: '原材料下单'
      }
    },
    {
      path: '/Sendcars',
      name: 'Sendcars',
      component: Sendcars,
      meta: {
        title: '派车单'
      }
    },
    {
      path: '/SendcarsDetail/:id',
      name: 'SendcarsDetail',
      component: SendcarsDetail,
      meta: {
        title: '派车单详情'
      }
    },
    {
      path: '/Credit',
      name: 'Credit',
      component: Credit,
      meta: {
        title: '账户余额'
      }
    },
    {
      path: '/CreditApply',
      name: 'CreditApply',
      component: CreditApply,
      meta: {
        title: '授信申请'
      }
    },
    {
        path:'*',
        component:Refresh
    }
  ]
})

//导航守卫
//使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
    // if (to.meta.requireAuthNo) {
    //     if (to.path === '/' ||to.path === '/login' || to.path === '/loginCode' || to.path === '/Manual') {
    //         next();
    //     } else {
    //         let token = localStorage.getItem('token');
    //         if (token ==undefined || token === null || token === '') {
    //             next('/');
    //         } else {
    //             next();
    //         }
    //     }
    // }else {
        next();
    // }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js